import { useEffect, useRef, useState } from "react";

export default function useResizeObserver() {
  const ref = useRef<HTMLElement>(null);
  const [rect, setRect] = useState<ResizeObserverEntry>();

  useEffect(() => {
    let observerRefValue: typeof ref.current = null;

    const observer = new ResizeObserver((entries) => {
      setRect(entries[0]);
    });

    if (ref.current) {
      observer.observe(ref.current);
      observerRefValue = ref.current;
    }

    return () => {
      observerRefValue && observer.unobserve(observerRefValue);
    };
  }, []);

  return { ref, rect };
}
